export interface RestrictedTradingCategory {
    state: string;
    categories: string[];
    subcategories?: string[];
    /** Marks entries enforced through GeoComply location verification. */
    geo?: boolean;
}

export interface FeatureFlags {
    blockNyZeroHash: boolean;
    isCardPaymentEnabled: boolean;
    interestRate: string;
    interestRateAmount?: string;
    enableWithdrawalMfa: boolean;
    enableNewMfaMethods: boolean;
    cryptoWithdrawEnabled: boolean;
    cryptoDepositEnabled: boolean;
    globalParlaysEnabled?: boolean;
    /** Always populated — seeded to `[]` in `defaultFeatureFlags` and by the `|| []` hydration path. */
    marketsToRemove: string[];
    attributionSurveyTitles?: string[];
    enableProps?: boolean;
    braintreePaypalEnabled?: boolean;
    braintreeVenmoEnabled?: boolean;
    bracketRules?: string;
    bracketEspnImportEnabled?: boolean;
    restrictedTradingCategories?: RestrictedTradingCategory[];
    logoLeagueRestrictions?: string[];
    worldCupPromoBanner?: boolean;
}

export const defaultFeatureFlags: FeatureFlags = {
    blockNyZeroHash: true,
    isCardPaymentEnabled: true,
    interestRate: '',
    interestRateAmount: '',
    enableWithdrawalMfa: false,
    enableNewMfaMethods: false,
    cryptoWithdrawEnabled: false,
    cryptoDepositEnabled: false,
    globalParlaysEnabled: false,
    marketsToRemove: [],
    attributionSurveyTitles: [],
    enableProps: false,
    braintreePaypalEnabled: true,
    braintreeVenmoEnabled: true,
    bracketEspnImportEnabled: false,
    restrictedTradingCategories: [],
    logoLeagueRestrictions: [],
    worldCupPromoBanner: false,
};

export interface FeatureFlagsReturn {
    block_new_yorkers_zero_hash: boolean;
    is_card_payment_enabled: boolean;
    interest_rate: string;
    interest_rate_amount: string;
    enable_withdrawal_mfa: boolean;
    enable_new_mfa_methods: boolean;
    crypto_withdraw_enabled: boolean;
    crypto_deposit_enabled: boolean;
    global_parlays_enabled: boolean;
    markets_to_remove: string[];
    attribution_survey_titles: string[];
    enable_props: boolean;
    braintree_paypal_enabled: boolean;
    braintree_venmo_enabled: boolean;
    bracket_rules?: string;
    bracket_espn_import_enabled?: boolean;
    restricted_trading_categories?: RestrictedTradingCategory[];
    logo_league_restrictions?: string[];
    world_cup_promo_banner?: boolean;
}
